angular.module('wbDashboard').controller('PlansDetailFeatureCreateIraAccountControllerAurea', ['$scope', 'Message', 'User', 'Milestone', function ($scope, Message, User, Milestone) {

    if (!$scope.wbBeta) {
        $scope.$state.go('base.overview');
    }

    if ($scope.$stateParams.page !== 'account') {
        $scope.$state.go(".", {page:'account'});
    }
    $scope.pageData.page = $scope.$stateParams.page;
    $scope.pageData.view = {footer: true};
    $scope.pages = ['account', 'annual-limit', 'initial-deposit', 'auto-deposit', 'confirm', 'submit'];

    //to trigger different messaging on milestone pages:
    $scope.newIra = true;

    Milestone.clearMS();
    $scope.milestone = Milestone.ms;
    $scope.MS = Milestone;

    $scope.$watch('availableAccounts', function(accounts) {
        if (accounts) {
            Milestone.data.retirement.accountsAvailable = accounts;
            if (!accounts.length || $scope.status.hasIraPending) {
                $scope.$state.go(".^", {location: "replace"});
                Message.set({
                    text:"Unable to create a new IRA account while other accounts are pending.",
                    type: "warning"
                });
            }
        }
    });
    $scope.$watch('retirement', function(retirement) {
        if (retirement) {
            Milestone.setMilestoneUpdateFromObject(retirement);

            $scope.milestone.accounts = [{auto_deposit: null, annual_deposit_limit: null}];
            $scope.milestone.initial_deposit = null;

            Milestone.getAvailable({msId:retirement.id});
        }
    });
    $scope.$watch('milestone.extra.account_type', function(type) {
        if (type) {
            $scope.milestone.accounts[0].account_number = null;
            $scope.milestone.accounts[0].type = type;
            $scope.milestone.accounts[0].name = type.replace('-', ' ').replace("Ira", "IRA").replace(/\b[a-z]/g, l => l.toUpperCase());
        }

        // if (type !== "Personal Investment Account") {
        //
        // }

    });
    $scope.goNextPage = function() {
        var pageIndex = $scope.pages.indexOf($scope.$stateParams.page);
        var nextPage;

        nextPage = $scope.pages[pageIndex+1];

        nextPage = $scope.beforePage(nextPage);

        if (nextPage === 'submit') {
            $scope.submit();
        } else {
            $scope.goToPage(nextPage);
        }

    };
    /**
     * Actions preformed to initialize page, or change page
     * @param page
     * @returns {*}
     */
    $scope.beforePage = function(page) {
        var nextPage = page;
        var pageIndex = $scope.pages.indexOf(page);

        switch (nextPage) {
            case 'auto-deposit':
                //skip auto-deposit page if calculated_waterfall
                if ($scope.milestone.metadata.funding_strategy === 'calculated_waterfall') {
                    nextPage = $scope.pages[pageIndex+1];
                }
                break;
        }
        if (nextPage !== page) {
            nextPage = $scope.beforePage(nextPage);
        }
        return nextPage;
    };
    $scope.goToPage = function(page) {
        $scope.$state.go(".",{page:page});
    };

    $scope.submit = function() {
        $scope.pageData.sending = true;

        var funding = {
            account_type: $scope.milestone.accounts[0].name,
            one_time_deposit: $scope.milestone.initial_deposit,
            annual_deposit_limit: $scope.milestone.accounts[0].annual_deposit_limit,
            auto_deposit_amount: $scope.milestone.auto_deposit.amount
        };
        Milestone.add_account({
            msId:$scope.retirement.id,
            funding: funding
        }).then(function(response) {
            User.retrieveOverview(true);
            User.retrieveMilestones($scope.retirement.id, true);

            $scope.$state.go("base.receipt", { receipt: {
                    "action": "ADD_ACCOUNT",
                    "type": "retirement",
                    "account_type": funding.account_type,
                    "amount": funding.one_time_deposit,
                    "plaid": true
                }});

        }).catch(function() {
            $scope.pageData.sending = false;
            Message.set({
                text:"Something went wrong, please try again. If you continue to have problems, please email support@axosinvest.com.",
                type: "danger"
            });
        });
    };

    var transitionDeregisterHook = $scope.$transitions.onSuccess({ to: $scope.$state.current.name+".**" }, function(trans) {
        $scope.pageData.page = trans.params('to').page;
        $scope.pageData.view.footer = true;
    });
    $scope.$on('$destroy', function() {
        if (transitionDeregisterHook) {
            transitionDeregisterHook();
        }
    });


}]);
